var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-card",
    [
      _c(
        "div",
        {
          staticClass: "clearfix",
          staticStyle: { display: "flex", "align-items": "center" },
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _vm.showTitle ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
          _c(
            "el-upload",
            {
              ref: "upload",
              staticStyle: {
                "margin-left": "20px",
                display: "inline-block",
                "line-height": "0",
              },
              attrs: {
                accept: _vm.attachmentAccept,
                "before-upload": _vm.beforeUpload,
                "show-file-list": _vm.showFileList,
                headers: _vm.header,
                action: _vm.fileUploadUrl,
                "on-success": _vm.uploadSuccess,
                multiple: _vm.multiple,
              },
            },
            [
              _c("el-button", { attrs: { type: "primary" } }, [
                _vm._v(_vm._s(_vm.$t("common.upload"))),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "inline-block", "margin-left": "1em" } },
            [_vm._t("header")],
            2
          ),
        ],
        1
      ),
      _vm._l(_vm.files, function (file, index) {
        return _c(
          "div",
          { key: index, staticStyle: { "line-height": "40px" } },
          [
            _c(
              "el-link",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.downloadFile(file)
                  },
                },
              },
              [_vm._v(_vm._s(file.documentName))]
            ),
            !_vm.disabled
              ? _c("el-button", {
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    type: "danger",
                    size: "mini",
                    icon: "el-icon-delete",
                    circle: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.delFile(file, index)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }